/** Truncate long stage names for display in chart axes; full names remain available in tooltips. */
export const truncateStageName = (name: string, maxLength = 14): string => {
	if (!name) {
		return '';
	}
	if (name.length <= maxLength) {
		return name;
	}
	return `${name.slice(0, Math.max(1, maxLength - 1)).trimEnd()}…`;
};
